var FGTPrintPassUtil = (function($){
    var $resendButton;
    var $msgResend;
    var orderId;
    var url;

    function setOrderId(id){
        orderId = id;
    }

    function setPrintPassUrl(){
        url = 'job/printpass/' + orderId;
    }

    function hideMessage(){
        $msgResend.hide();
    }

    function setButtonInFlight(){
        $resendButton
            .removeClass('btn-buy')
            .prop('disabled', true)
            .text('Sending');
    }

    function setButtonDone(){
        $resendButton.text('Sent');
    }

    function resetButton() {
        setTimeout(function() {
            $resendButton
                .one('click', resendHandler)
                .prop('disabled', false)
                .addClass('btn-buy')
                .text('Resend Passes')
                .blur();
        }, 5000);
    }

    function resendHandler(e){
        e.preventDefault();

        hideMessage();
        setButtonInFlight();

        var ajax = new FG.Ajax(url);
        ajax.setRequestType('get');
        ajax.setMessageDiv($msgResend);

        try {
            ajax.setSuccessCallback(setButtonDone);
            ajax.setFailureCallback(resetButton);
            ajax.send();
        } catch (AjaxException){
            ajax.error('Passes failed to resend.');
            resetButton();
        }
    }

    function initPrintPass(id) {
        $resendButton = $('#resend-button');
        $msgResend = $('#msg-resend');
        setOrderId(id);
        setPrintPassUrl();
        $resendButton.one('click', resendHandler);
    }

    return {
        initPrintPass: initPrintPass
    };
}(window.jQuery));
